import { render, staticRenderFns } from "./erOptionGroup.vue?vue&type=template&id=4157d5a8&scoped=true&"
import script from "./erOptionGroup.vue?vue&type=script&lang=js&"
export * from "./erOptionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157d5a8",
  null
  
)

export default component.exports